
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {BROKEN_IMAGE_REASONS, findBrokenImages, IBrokenImage} from '@/services/helpdeskEmailImages';

export const FIX_IN_EDITOR = 'guarda la imagen en tu ordenador, bórrala de aquí y vuelve a añadirla con el botón '
  + '«Insertar imagen» (o arrastrándola o pegándola como archivo).';

@Component({name: 'BrokenImagesNotice'})
export default class BrokenImagesNotice extends Vue {
  @Prop({default: ''}) html!: string;
  // Images the browser failed to load (only the editor knows them).
  @Prop({type: Array, default: () => []}) failedSrcs!: string[];
  @Prop({default: FIX_IN_EDITOR}) fix!: string;
  // Icon + count with the explanation in a tooltip (cards, lists).
  @Prop({type: Boolean, default: false}) compact!: boolean;
  @Prop({type: Boolean, default: false}) removable!: boolean;

  get problems(): IBrokenImage[] {
    return findBrokenImages(this.html, this.failedSrcs);
  }

  get title(): string {
    return this.problems.length === 1
      ? '1 imagen no le llegará al destinatario'
      : this.problems.length + ' imágenes no le llegarán al destinatario';
  }

  get reasons(): Array<{reason: string; text: string; count: number}> {
    const out: Array<{reason: string; text: string; count: number}> = [];
    this.problems.forEach((p) => {
      const row = out.filter((r) => r.reason === p.reason)[0];
      if (row) row.count++;
      else out.push({reason: p.reason, text: BROKEN_IMAGE_REASONS[p.reason], count: 1});
    });
    return out;
  }

  get fixText(): string {
    return this.fix.charAt(0).toUpperCase() + this.fix.slice(1);
  }
}
